import PropTypes from 'prop-types';
import React from 'react';
import DateField from './index';

export default function renderDateField({ input, meta: { touched, error, warning }, ...args }) {
  const validationMessage = touched ? error || warning : null;
  const isValid = !(error || warning);
  const id = args.id || input.name || null;
  const startDate = input.value.get ? input.value.get(0) : input.value[0] || null;
  const endDate = input.value.get ? input.value.get(1) : input.value[1] || null;
  return (
    <DateField
      handleChangeStart={(start) => input.onChange([start, endDate || null])}
      startDateValue={startDate}
      handleChangeEnd={(end) => input.onChange([startDate || null, end])}
      endDateValue={endDate}
      validationMessage={validationMessage}
      isValid={isValid}
      id={id}
      {...args}
      {...input}
    />
  );
}
renderDateField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
};
